module.exports = __webpack_public_path__ + "img/marketing-icon-card.57ccbeaf.svg";